module.exports = __webpack_public_path__ + "static/media/efesHomepageHeaderImage.b98278de.png";